import { createFileRoute } from "@tanstack/react-router";
import { LocalizationDefinitionsPage } from "../../../components/system/LocalizationDefinitionsPage";
import { requireSuperAdmin } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/localization/definitions")({
  beforeLoad: requireSuperAdmin(),
  validateSearch: (search: Record<string, unknown>): { lang?: string } => ({
    lang:
      typeof search.lang === "string" && search.lang.trim()
        ? search.lang.trim().toLowerCase()
        : undefined,
  }),
  component: LocalizationDefinitionsRoute,
});

function LocalizationDefinitionsRoute() {
  const { lang } = Route.useSearch();
  return <LocalizationDefinitionsPage initialLang={lang} />;
}
